import { render, staticRenderFns } from "./AuctionCover.vue?vue&type=template&id=34ea9cb5&scoped=true"
import script from "./AuctionCover.vue?vue&type=script&lang=js"
export * from "./AuctionCover.vue?vue&type=script&lang=js"
import style0 from "./AuctionCover.vue?vue&type=style&index=0&id=34ea9cb5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ea9cb5",
  null
  
)

export default component.exports